/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { ClientId } from '../../models/client-id';

export interface InitializeCheckoutV2$Params {

/**
 * CAS authentication token in Bearer format. Takes priority over the Authorization header if both are present.
 */
  oauth_token?: any;
  cartId?: string;
  orderId?: string;
  orderChangeId?: string;
  locale?: string;
  hash?: string;
  'True-Client-IP'?: string;
  'X-Forwarded-For'?: string;
  device?: string;
  service?: string;
  successUrl: string;
  failureUrl: string;
  testVariant?: string;
  checkoutTheme?: string;

/**
 * Session ID in UUID format used to aggregate all the calls for a single customer
 */
  'X-Session-Id'?: string;

/**
 * Client ID representing the caller system
 */
  'X-Client-Id'?: ClientId;

/**
 * W3C Trace Context traceparent header used for distributed tracing
 */
  traceparent?: string;

/**
 * W3C Trace Context tracestate header used for distributed tracing
 */
  tracestate?: string;

/**
 * W3C Baggage header used to propagate contextual key-value pairs
 */
  baggage?: string;
}

export function initializeCheckoutV2(http: HttpClient, rootUrl: string, params: InitializeCheckoutV2$Params, context?: HttpContext): Observable<DapiHttpResponse<void>> {
  const rb = new DapiRequestBuilder(rootUrl, initializeCheckoutV2.PATH, 'post');

  if (params) {
    rb.header('oauth_token', params.oauth_token, {});
    rb.query('cartId', params.cartId, {});
    rb.query('orderId', params.orderId, {});
    rb.query('orderChangeId', params.orderChangeId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
    rb.header('True-Client-IP', params['True-Client-IP'], {});
    rb.header('X-Forwarded-For', params['X-Forwarded-For'], {});
    rb.query('device', params.device, {});
    rb.query('service', params.service, {});
    rb.query('successUrl', params.successUrl, {});
    rb.query('failureUrl', params.failureUrl, {});
    rb.query('testVariant', params.testVariant, {});
    rb.query('checkoutTheme', params.checkoutTheme, {});
    rb.header('X-Session-Id', params['X-Session-Id'], {});
    rb.header('X-Client-Id', params['X-Client-Id'], {});
    rb.header('traceparent', params.traceparent, {});
    rb.header('tracestate', params.tracestate, {});
    rb.header('baggage', params.baggage, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as DapiHttpResponse<void>;
    }),
    catchErrorAsJson()
  );
}

initializeCheckoutV2.PATH = '/api/v2/checkout/initialize';
